const contractTemplateStatus = Object.freeze({
  Borrador: 3095,
  Publicado: 3096,
});

export default contractTemplateStatus;

const getContractTemplateStatusColor = (statusId) => {
  switch (statusId) {
    case contractTemplateStatus.Borrador:
      return 'gray';
    case contractTemplateStatus.Publicado:
      return 'green-light';
    default:
      return '';
  }
};

export { getContractTemplateStatusColor };
